import { Fragment, useEffect, useMemo, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { getItemsFromObject } from "../../../../services/array/transformObject";
import { supportedCurrencies } from "../../../../app/constants/currencies";
import { mapCurrencyToSymbols } from "../../../../services/format/currency";
import { useAppDispatch } from "../../../../app/store";
import { setSelectedCurrency } from "../topNavbarSlice";

const CurrencyDropDown = () => {
    const dispatch = useAppDispatch();
    const currencies = useMemo(() => getItemsFromObject(supportedCurrencies), []);
    const [currency, setCurrency] = useState(currencies[0]);

    useEffect(() => {
        dispatch(setSelectedCurrency(currency));
    }, [currency, dispatch]);

    return (
        <>
            <NavDropdown
                title={
                    <>
                        <span className="navbar-icon currency-icon">{`${mapCurrencyToSymbols(currency)}`}</span>
                        {currency}
                    </>
                }
                className="currency-dropdown"
                id="currency-dropdown"
            >
                {currencies.map((item, index) => (
                    <Fragment key={`currency-${item}`}>
                        <NavDropdown.Item onClick={() => setCurrency(item)}>
                            <>
                                <span className="navbar-icon currency-icon">{`${mapCurrencyToSymbols(item)}`}</span>
                                {item}
                            </>
                        </NavDropdown.Item>
                        {index + 1 !== currencies.length && <NavDropdown.Divider />}
                    </Fragment>
                ))}
            </NavDropdown>
        </>
    );
};

export default CurrencyDropDown;
